import Clarity from '@microsoft/clarity';
import { appServices } from '~/config/app';

let clarityStarted = false;

export const applyClarityConsent = (granted: boolean) => {
  const projectId = appServices.msClarityCode;
  if (!projectId) {
    return;
  }

  if (!clarityStarted) {
    Clarity.init(projectId);
    clarityStarted = true;
  }

  Clarity.consentV2({
    ad_Storage: 'denied',
    analytics_Storage: granted ? 'granted' : 'denied',
  });
};

// Visible for testing
export const resetClarityState = () => {
  clarityStarted = false;
};
